export default "__VITE_ASSET__rZ3briR1__"